import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Tooltip, SelectionToolIcon } from '@frontend/components';

import ViewerButton from '../components/ViewerButton';
import ViewerButtonTooltip from '../components/ViewerButtonTooltip';
import { selectorTool } from '../data/actions';
import { getIsSelectorToolActive } from '../data/reducer';

const SelectorTool = ({
  isEnabled, // passed in as direct prop
}) => {
  const isActive = useSelector(getIsSelectorToolActive);
  const dispatch = useDispatch();
  const toggleSelectorTool = useCallback(() => {
    dispatch(selectorTool.toggle());
  }, [dispatch]);
  return isEnabled ? (
    <Tooltip
      placement="bottom"
      label={
        <ViewerButtonTooltip
          firstLine="Selection Tool"
          secondLine="CTRL + drag LMB to Box Select"
        />
      }
    >
      <ViewerButton isActive={isActive} onClick={toggleSelectorTool}>
        <SelectionToolIcon boxSize={2.5} />
      </ViewerButton>
    </Tooltip>
  ) : null;
};

export default SelectorTool;
